/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { editCountry ,saveCountry , isEdit ,processing ,setisEdit}
) =>{

  const callEditFunction = async (row) => {
    editCountry(row);
  }
  const callSaveFunction = async (row) => {
    saveCountry(row);
  }
  const callCancelButtonFunction = async () => {
    setisEdit('');
  }

  if(isEdit === row.id)
  {
    if(processing === "save"+row.id)
    {
      return (<i className="fas fa-circle-notch fa-spin"></i>)
    }
    else
    {
      return (
        <>
          <button type="button" className="btn btn-primary" onClick={()=>callSaveFunction(row)}>Save</button>
          <button type="button" className="btn btn-danger ml-1" onClick={()=>callCancelButtonFunction()}>Cancel</button>
        </>
      )
    }
  }
  else
  {
  return  (
    <>
      <OverlayTrigger
        overlay={<Tooltip id="users-edit-tooltip">Edit user</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-primary btn-sm"
          onClick={()=>callEditFunction(row)} 
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>
    </>
  )
  }
}
